import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  "clip-path": "url(#clip0_6858_9609)"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M2.33301 1.66797H3.42148C3.62649 1.66797 3.729 1.66797 3.81149 1.70567C3.88419 1.73889 3.9458 1.79232 3.98897 1.85959C4.03795 1.93592 4.05245 2.0374 4.08144 2.24035L4.47586 5.0013M4.47586 5.0013L5.35244 11.4441C5.46368 12.2617 5.5193 12.6705 5.71476 12.9783C5.88699 13.2494 6.13391 13.465 6.4258 13.5991C6.75706 13.7513 7.16963 13.7513 7.99476 13.7513H15.1263C15.9118 13.7513 16.3045 13.7513 16.6255 13.61C16.9085 13.4854 17.1512 13.2845 17.3266 13.0298C17.5254 12.741 17.5989 12.3552 17.7459 11.5836L18.8489 5.79271C18.9007 5.52114 18.9265 5.38536 18.889 5.27922C18.8562 5.18611 18.7913 5.10771 18.706 5.05798C18.6087 5.0013 18.4705 5.0013 18.194 5.0013H4.47586ZM8.99967 17.5013C8.99967 17.9615 8.62658 18.3346 8.16634 18.3346C7.7061 18.3346 7.33301 17.9615 7.33301 17.5013C7.33301 17.0411 7.7061 16.668 8.16634 16.668C8.62658 16.668 8.99967 17.0411 8.99967 17.5013ZM15.6663 17.5013C15.6663 17.9615 15.2932 18.3346 14.833 18.3346C14.3728 18.3346 13.9997 17.9615 13.9997 17.5013C13.9997 17.0411 14.3728 16.668 14.833 16.668C15.2932 16.668 15.6663 17.0411 15.6663 17.5013Z",
  stroke: "var(--icon-stroke)",
  "stroke-width": "1.4",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
})], -1);
const _hoisted_3 = {
  id: "clip0_6858_9609"
};
const _hoisted_4 = ["width", "height"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: $props.width,
    height: $props.height,
    viewBox: `0 0 20 20`,
    fill: "none",
    style: _normalizeStyle({
      '--icon-stroke': $props.color
    })
  }, [_hoisted_2, _createElementVNode("defs", null, [_createElementVNode("clipPath", _hoisted_3, [_createElementVNode("rect", {
    width: $props.width,
    height: $props.width,
    fill: "white",
    transform: "translate(0.666504)"
  }, null, 8, _hoisted_4)])])], 12, _hoisted_1);
}